import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumb, BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import LocationForm from '@app/components/apps/Locations/LocationForm';
import { useHeader } from '@app/components/header/layouts/HeaderContext';

export const ViewLocationPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Location');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/locations',
      breadcrumbName: 'Locations',
    },
    {
      path: '/view-location',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <LocationForm
          type={'view'}
          editable={false}
          id={id}
          pageTitle={`View Location`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Row>
    </>
  );
};

export default ViewLocationPage;
